module.exports = __webpack_public_path__ + "add17af0fdf6a49e090e4abc9d8eb5bb.pdf";